import React from "react";
import { NavLink } from "react-router-dom";
import { Button } from "reactstrap";
import { useAuth } from "../Context/AuthenticateProvider";
import Logo from "../Assets/images/logo.png";

const Sidebar = () => {
    const { logOut, userRole } = useAuth();
    const isAdmin = !userRole || userRole.toLowerCase() === 'admin';

    return (
        <>
            <aside className="app-sidebar">
                <div className="sidebar-top">
                    <div className="sidebar-logo">
                        <img src={Logo} alt="logo" />
                    </div>
                </div>

                <div className="sidebar-scroll">
                    <div className="sidebar-section">Main</div>
                    <div className="inventory-menus">
                        <NavLink to="/" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-home"></i> Dashboard
                        </NavLink>
                    </div>

                    <div className="sidebar-section">Quotation</div>
                    <div className="inventory-menus">
                        <NavLink to="/quotations" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bxs-quote-alt-left"></i> Quotations
                        </NavLink>
                        <NavLink to="/quotation/add" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-chat"></i> Create
                        </NavLink>
                    </div>

                    <div className="sidebar-section">Invoices</div>
                    <div className="inventory-menus">
                        <NavLink to="/invoices" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-cube"></i> Invoices
                        </NavLink>
                        {isAdmin && (
                            <NavLink to="/payments" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                <i className="bx bx-cube"></i> Payments
                            </NavLink>
                        )}
                        <NavLink to="/invoice/add" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                            <i className="bx bx-plus-circle"></i> New Invoice
                        </NavLink>
                    </div>

                    {isAdmin && (
                        <>
                            <div className="sidebar-divider"></div>
                            <div className="sidebar-section">Customers</div>
                            <div className="inventory-menus">
                                <NavLink to="/customers" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                    <i className="bx bx-user"></i> Customers
                                </NavLink>
                                <NavLink to="/customer/add" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                    <i className="bx bx-plus-circle"></i> New Customer
                                </NavLink>
                            </div>

                            <div className="sidebar-section">Expenses</div>
                            <div className="inventory-menus">
                                <NavLink to="/expenses/add" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                    <i className='bx bx-money-withdraw'></i> Expenses
                                </NavLink>
                            </div>

                            <div className="sidebar-section">Vehicles</div>
                            <div className="inventory-menus">
                                <NavLink to="/vehicles" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                    <i className="bx bx-user"></i> Vehicles
                                </NavLink>
                                <NavLink to="/vehicle/add" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                    <i className="bx bx-plus-circle"></i> New Vehicle
                                </NavLink>
                            </div>

                            <div className="sidebar-section">Prices</div>
                            <div className="inventory-menus">
                                <NavLink to="/prices" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                    <i className="bx bx-user"></i> Prices
                                </NavLink>
                                <NavLink to="/price/add" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                    <i className="bx bx-plus-circle"></i> New Price
                                </NavLink>
                            </div>

                            <div className="sidebar-section">Drivers</div>
                            <div className="inventory-menus">
                                <NavLink to="/drivers" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                    <i className="bx bx-user"></i> Drivers
                                </NavLink>
                                <NavLink to="/driver/add" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                    <i className="bx bx-plus-circle"></i> New Driver
                                </NavLink>
                                <NavLink to="/driver/logs" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                    <i className="bx bx-time"></i> Work Logs
                                </NavLink>
                            </div>

                            <div className="sidebar-section">Reports</div>
                            <div className="inventory-menus">
                                <NavLink to="/reports/delivery" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                    <i className='bx bx-user'></i> Work Log Summary
                                </NavLink>
                                <NavLink to="/reports/expenses" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                    <i className='bx bx-user'></i> Expenses Summary
                                </NavLink>
                                <NavLink to="/reports/revenue" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                    <i className='bx bx-signal-4'></i> Revenue Summary
                                </NavLink>
                                <NavLink to="/reports/customer" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                    <i className='bx bx-receipt'></i> Customer Summary
                                </NavLink>
                            </div>

                            <div className="sidebar-section">Settings</div>
                            <div className="inventory-menus">
                                <NavLink to="/settings" className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                                    <i className='bx bx-cog'></i> Settings
                                </NavLink>
                            </div>
                        </>
                    )}
                </div>

                <div className="sidebar-footer">
                    <div className="sidebar-logo">
                        <Button className="logout-btn" onClick={logOut}>Logout</Button>
                    </div>
                </div>
            </aside>
        </>
    );
};

export default Sidebar;
